import { render } from "./routerNavigation.vue?vue&type=template&id=464d37fc&scoped=true"
import script from "./routerNavigation.vue?vue&type=script&lang=js"
export * from "./routerNavigation.vue?vue&type=script&lang=js"

import "./routerNavigation.vue?vue&type=style&index=0&id=464d37fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464d37fc"]])

export default __exports__